function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { openDB } from 'idb';
import toast from 'react-hot-toast'; // toast 임포트 추가
import { v4 as uuidv4 } from 'uuid';
var COURSE_SNAPSHOT_PREFIX = 'course:';
var CURRICULUM_PERSIST_BASE_KEY = 'curriculum-editor-state';
var CURRICULUM_PERSIST_KEY_PREFIX = "".concat(CURRICULUM_PERSIST_BASE_KEY, "::");
var sanitizeLanguageCode = function(languageCode) {
    if (!languageCode) {
        return null;
    }
    var trimmed = languageCode.trim();
    if (!trimmed) {
        return null;
    }
    return trimmed.toLowerCase();
};
var buildSnapshotKey = function(courseId, languageCode) {
    if (courseId === undefined || courseId === null) {
        return null;
    }
    var trimmed = String(courseId).trim();
    if (!trimmed) {
        return null;
    }
    var baseKey = trimmed.startsWith(COURSE_SNAPSHOT_PREFIX) ? trimmed : "".concat(COURSE_SNAPSHOT_PREFIX).concat(trimmed);
    var sanitizedLanguage = sanitizeLanguageCode(languageCode);
    if (!sanitizedLanguage) {
        return baseKey;
    }
    return "".concat(baseKey, "::").concat(sanitizedLanguage);
};
var buildPersistStorageName = function(courseId) {
    var snapshotKey = buildSnapshotKey(courseId);
    if (!snapshotKey) {
        return "".concat(CURRICULUM_PERSIST_KEY_PREFIX, "global");
    }
    return "".concat(CURRICULUM_PERSIST_KEY_PREFIX).concat(snapshotKey);
};
var normalizeSnapshotKey = function(rawKey) {
    if (!rawKey) {
        return null;
    }
    return rawKey.startsWith(COURSE_SNAPSHOT_PREFIX) ? rawKey : buildSnapshotKey(rawKey);
};
var cloneSections = function(sections) {
    return (sections || []).map(function(section) {
        return _object_spread_props(_object_spread({}, section), {
            lessons: (section.lessons || []).map(function(lesson) {
                return _object_spread({}, lesson);
            })
        });
    });
};
var clonePersistedSnapshot = function(snapshot) {
    var _snapshot_lastModifiedLocallyTimestamp;
    return {
        sections: cloneSections(snapshot.sections || []),
        selectedLesson: snapshot.selectedLesson ? _object_spread({}, snapshot.selectedLesson) : null,
        lastModifiedLocallyTimestamp: (_snapshot_lastModifiedLocallyTimestamp = snapshot.lastModifiedLocallyTimestamp) !== null && _snapshot_lastModifiedLocallyTimestamp !== void 0 ? _snapshot_lastModifiedLocallyTimestamp : null,
        isCurriculumDirty: snapshot.isCurriculumDirty
    };
};
var normalizePersistedSnapshots = function(snapshots) {
    if (!snapshots) {
        return {};
    }
    var normalized = {};
    Object.entries(snapshots).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), rawKey = _param[0], snapshot = _param[1];
        var key = normalizeSnapshotKey(rawKey);
        if (key) {
            normalized[key] = clonePersistedSnapshot(snapshot);
        }
    });
    return normalized;
};
var updateCourseSnapshot = function(state, overrides, courseIdOverride, languageOverride) {
    var snapshotKey = buildSnapshotKey(courseIdOverride !== null && courseIdOverride !== void 0 ? courseIdOverride : state.currentEditingCourseId, languageOverride !== null && languageOverride !== void 0 ? languageOverride : state.currentLanguage);
    if (!snapshotKey) {
        return state.persistedCourseSnapshots;
    }
    var _state_lastModifiedLocallyTimestamp;
    var baseSnapshot = state.persistedCourseSnapshots[snapshotKey] || {
        sections: cloneSections(state.sections),
        selectedLesson: state.selectedLesson ? _object_spread({}, state.selectedLesson) : null,
        lastModifiedLocallyTimestamp: (_state_lastModifiedLocallyTimestamp = state.lastModifiedLocallyTimestamp) !== null && _state_lastModifiedLocallyTimestamp !== void 0 ? _state_lastModifiedLocallyTimestamp : null,
        isCurriculumDirty: state.isCurriculumDirty
    };
    var _overrides_sections;
    var resolvedSections = (_overrides_sections = overrides.sections) !== null && _overrides_sections !== void 0 ? _overrides_sections : baseSnapshot.sections;
    var resolvedSelectedLesson = overrides.selectedLesson !== undefined ? overrides.selectedLesson : baseSnapshot.selectedLesson;
    var _overrides_lastModifiedLocallyTimestamp, _ref, _overrides_isCurriculumDirty;
    var nextSnapshot = {
        sections: cloneSections(resolvedSections || []),
        selectedLesson: resolvedSelectedLesson ? _object_spread({}, resolvedSelectedLesson) : null,
        lastModifiedLocallyTimestamp: (_ref = (_overrides_lastModifiedLocallyTimestamp = overrides.lastModifiedLocallyTimestamp) !== null && _overrides_lastModifiedLocallyTimestamp !== void 0 ? _overrides_lastModifiedLocallyTimestamp : baseSnapshot.lastModifiedLocallyTimestamp) !== null && _ref !== void 0 ? _ref : null,
        isCurriculumDirty: (_overrides_isCurriculumDirty = overrides.isCurriculumDirty) !== null && _overrides_isCurriculumDirty !== void 0 ? _overrides_isCurriculumDirty : baseSnapshot.isCurriculumDirty
    };
    return _object_spread_props(_object_spread({}, state.persistedCourseSnapshots), _define_property({}, snapshotKey, nextSnapshot));
};
// --- IndexedDB 설정 ---
var DB_NAME = 'CurriculumDB';
var STORE_NAME = 'courseData';
var VERSION = 1;
// 데이터베이스 인스턴스 Promise (싱글톤)
var dbPromise = null;
var getDb = function() {
    if (!dbPromise) {
        dbPromise = openDB(DB_NAME, VERSION, {
            upgrade: function upgrade(db) {
                if (!db.objectStoreNames.contains(STORE_NAME)) {
                    db.createObjectStore(STORE_NAME); // 객체 저장소 생성
                }
            }
        });
    }
    return dbPromise;
};
// --- Zustand Persist를 위한 IndexedDB 스토리지 어댑터 ---
var indexedDbStorage = {
    getItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(name) {
            var db, storedValue, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("IndexedDB getItem: ".concat(name));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            getDb()
                        ];
                    case 2:
                        db = _state.sent();
                        return [
                            4,
                            db.get(STORE_NAME, name)
                        ];
                    case 3:
                        storedValue = _state.sent();
                        // console.log('Retrieved from IndexedDB:', storedValue);
                        return [
                            2,
                            storedValue !== null && storedValue !== void 0 ? storedValue : null
                        ];
                    case 4:
                        error = _state.sent();
                        console.error("Failed to get item '".concat(name, "' from IndexedDB:"), error);
                        return [
                            2,
                            null
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(name) {
            return _ref.apply(this, arguments);
        };
    }(),
    setItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(name, value) {
            var db, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("IndexedDB setItem: ".concat(name));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            getDb()
                        ];
                    case 2:
                        db = _state.sent();
                        return [
                            4,
                            db.put(STORE_NAME, value, name)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.error("Failed to set item '".concat(name, "' in IndexedDB:"), error);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(name, value) {
            return _ref.apply(this, arguments);
        };
    }(),
    removeItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(name) {
            var db, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("IndexedDB removeItem: ".concat(name));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            getDb()
                        ];
                    case 2:
                        db = _state.sent();
                        return [
                            4,
                            db.delete(STORE_NAME, name)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.error("Failed to remove item '".concat(name, "' from IndexedDB:"), error);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(name) {
            return _ref.apply(this, arguments);
        };
    }()
};
// sections 객체를 비교 가능한 문자열로 변환 (dirty check용)
var sectionsToString = function(sections) {
    // ID, order 등 주요 구조와 내용을 포함하여 문자열화
    // 너무 복잡하면 간단히 JSON.stringify 사용 후, 주요 필드만으로 최적화 고려
    return JSON.stringify(sections.map(function(s) {
        return {
            id: s.id,
            title: s.title,
            order: s.order,
            lessons: s.lessons.map(function(l) {
                return {
                    id: l.id,
                    title: l.title,
                    markdown: l.markdown,
                    order: l.order
                };
            })
        };
    }));
};
var curriculumStateCreator = function(set, get) {
    return {
        // Course Basic Info 초기값
        courseId: null,
        title: null,
        description: null,
        level: null,
        thumbnailUrl: null,
        priceAmount: null,
        priceCurrency: null,
        isPublic: null,
        allowComments: null,
        instructorName: null,
        // Curriculum Structure 초기값
        sections: [],
        initialSectionsString: '[]',
        currentEditingCourseId: null,
        currentLanguage: null,
        selectedLesson: null,
        editingSectionId: null,
        editingSectionTitleCache: '',
        editingLessonId: null,
        editingLessonTitleCache: '',
        editingLessonMarkdownCache: '',
        isAddingSection: false,
        addingLessonToSectionId: null,
        isCurriculumDirty: false,
        lastModifiedLocallyTimestamp: null,
        serverLastUpdatedAt: null,
        persistedCourseSnapshots: {},
        // 액션 구현
        setSections: function(newSections) {
            console.log("[CurriculumStore] setSections called. Setting isCurriculumDirty to true. CourseID: ".concat(get().currentEditingCourseId));
            set(function(state) {
                var timestamp = Date.now();
                return {
                    sections: newSections,
                    isCurriculumDirty: true,
                    lastModifiedLocallyTimestamp: timestamp,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: newSections,
                        lastModifiedLocallyTimestamp: timestamp,
                        isCurriculumDirty: true
                    })
                };
            });
        },
        initializeSections: function(newSectionsToInitialize, courseId, options) {
            var currentState = get();
            var _ref = options || {}, providedTimestamp = _ref.providedTimestamp, markAsDirtyOnImport = _ref.markAsDirtyOnImport, language = _ref.language;
            var _sanitizeLanguageCode;
            var resolvedLanguage = (_sanitizeLanguageCode = sanitizeLanguageCode(language)) !== null && _sanitizeLanguageCode !== void 0 ? _sanitizeLanguageCode : sanitizeLanguageCode(currentState.currentLanguage);
            console.log("[CurriculumStore] initializeSections CALLED. CourseID: ".concat(courseId, ", language: ").concat(resolvedLanguage !== null && resolvedLanguage !== void 0 ? resolvedLanguage : 'default'), "\n  Current Store CourseID: ".concat(currentState.currentEditingCourseId), "\n  Current Store Language: ".concat(currentState.currentLanguage), "\n  Local Timestamp: ".concat(currentState.lastModifiedLocallyTimestamp), "\n  Provided Timestamp (server/import): ".concat(providedTimestamp));
            var snapshotKey = buildSnapshotKey(courseId, resolvedLanguage);
            var existingSnapshot = snapshotKey ? currentState.persistedCourseSnapshots[snapshotKey] : undefined;
            var sectionsToSet = cloneSections(newSectionsToInitialize || []);
            var dirtyToSet = false;
            var localTimestampToSet = providedTimestamp !== null && providedTimestamp !== void 0 ? providedTimestamp : null;
            var decisionReason = '';
            var usedSnapshot = false;
            var _existingSnapshot_lastModifiedLocallyTimestamp;
            var snapshotTimestamp = (_existingSnapshot_lastModifiedLocallyTimestamp = existingSnapshot === null || existingSnapshot === void 0 ? void 0 : existingSnapshot.lastModifiedLocallyTimestamp) !== null && _existingSnapshot_lastModifiedLocallyTimestamp !== void 0 ? _existingSnapshot_lastModifiedLocallyTimestamp : null;
            var providedTimestampValue = providedTimestamp !== null && providedTimestamp !== void 0 ? providedTimestamp : null;
            var isSameCourse = currentState.currentEditingCourseId === courseId;
            var isSameLanguage = sanitizeLanguageCode(currentState.currentLanguage) === resolvedLanguage;
            if (!isSameCourse || !isSameLanguage) {
                decisionReason = 'Switching context (course or language). Checking snapshot availability.';
                if (existingSnapshot && snapshotTimestamp !== null) {
                    decisionReason += ' Found existing snapshot for course/language.';
                    sectionsToSet = cloneSections(existingSnapshot.sections || []);
                    dirtyToSet = existingSnapshot.isCurriculumDirty;
                    localTimestampToSet = snapshotTimestamp;
                    usedSnapshot = true;
                }
            } else if (existingSnapshot && snapshotTimestamp !== null && (!providedTimestampValue || snapshotTimestamp > providedTimestampValue)) {
                decisionReason = 'Local snapshot is newer than server data. Using snapshot.';
                sectionsToSet = cloneSections(existingSnapshot.sections || []);
                dirtyToSet = existingSnapshot.isCurriculumDirty;
                localTimestampToSet = snapshotTimestamp;
                usedSnapshot = true;
                toast('저장되지 않은 로컬 변경사항이 있어 로컬 데이터를 우선 표시합니다. 서버에 저장하여 동기화해주세요.', {
                    duration: 7000,
                    icon: 'ℹ️'
                });
            } else if (providedTimestampValue !== null) {
                decisionReason = 'Server/import data is considered authoritative.';
                localTimestampToSet = providedTimestampValue;
                dirtyToSet = false;
            } else {
                decisionReason = 'Fallback: Using provided data without timestamp.';
                localTimestampToSet = null;
                dirtyToSet = false;
            }
            if (markAsDirtyOnImport) {
                if (!decisionReason.includes('Marked as dirty due to import action.')) {
                    decisionReason += ' Marked as dirty due to import action.';
                }
                dirtyToSet = true;
                if (dirtyToSet) {
                    console.log("[CurriculumStore] initializeSections - markAsDirtyOnImport is true. Setting dirtyToSet to true. CourseID: ".concat(courseId, ", language: ").concat(resolvedLanguage !== null && resolvedLanguage !== void 0 ? resolvedLanguage : 'default'));
                }
                localTimestampToSet = Date.now();
            }
            console.log("[CurriculumStore] initializeSections DECISION: ".concat(decisionReason));
            console.log("[CurriculumStore] initializeSections - sectionsToSet (count): ".concat(sectionsToSet.length, ", dirtyToSet: ").concat(dirtyToSet, ", localTimestampToSet: ").concat(localTimestampToSet));
            set(function(state) {
                return {
                    sections: cloneSections(sectionsToSet),
                    currentEditingCourseId: courseId,
                    courseId: courseId,
                    currentLanguage: resolvedLanguage !== null && resolvedLanguage !== void 0 ? resolvedLanguage : null,
                    isCurriculumDirty: dirtyToSet,
                    selectedLesson: usedSnapshot && !markAsDirtyOnImport && (existingSnapshot === null || existingSnapshot === void 0 ? void 0 : existingSnapshot.selectedLesson) ? _object_spread({}, existingSnapshot.selectedLesson) : null,
                    editingSectionId: null,
                    editingLessonId: null,
                    editingSectionTitleCache: '',
                    editingLessonMarkdownCache: '',
                    isAddingSection: false,
                    addingLessonToSectionId: null,
                    lastModifiedLocallyTimestamp: localTimestampToSet,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: sectionsToSet,
                        selectedLesson: usedSnapshot && !markAsDirtyOnImport && (existingSnapshot === null || existingSnapshot === void 0 ? void 0 : existingSnapshot.selectedLesson) ? _object_spread({}, existingSnapshot.selectedLesson) : null,
                        lastModifiedLocallyTimestamp: localTimestampToSet,
                        isCurriculumDirty: dirtyToSet
                    }, courseId, resolvedLanguage !== null && resolvedLanguage !== void 0 ? resolvedLanguage : null)
                };
            });
        },
        resetCurriculumState: function() {
            console.log("Resetting curriculum state");
            set({
                sections: [],
                currentEditingCourseId: null,
                courseId: null,
                currentLanguage: null,
                selectedLesson: null,
                editingSectionId: null,
                editingSectionTitleCache: '',
                editingLessonId: null,
                editingLessonTitleCache: '',
                editingLessonMarkdownCache: '',
                isAddingSection: false,
                addingLessonToSectionId: null,
                isCurriculumDirty: false,
                lastModifiedLocallyTimestamp: null
            });
        },
        addSection: function(newSectionData) {
            return set(function(state) {
                var newId = newSectionData.id || "s_local_".concat(uuidv4());
                var newSectionObject = {
                    title: newSectionData.title,
                    id: newId,
                    lessons: [],
                    order: state.sections.length + 1
                };
                console.log('[zustand] addSection called. New section:', newSectionObject);
                var newSections = _to_consumable_array(state.sections).concat([
                    newSectionObject
                ]);
                var timestamp = Date.now();
                return {
                    sections: newSections,
                    isCurriculumDirty: true,
                    lastModifiedLocallyTimestamp: timestamp,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: newSections,
                        lastModifiedLocallyTimestamp: timestamp,
                        isCurriculumDirty: true
                    })
                };
            });
        },
        updateSectionTitle: function(sectionId, newTitle) {
            return set(function(state) {
                var newSections = state.sections.map(function(s) {
                    return s.id === sectionId ? _object_spread_props(_object_spread({}, s), {
                        title: newTitle
                    }) : s;
                });
                var timestamp = Date.now();
                return {
                    sections: newSections,
                    editingSectionId: null,
                    isCurriculumDirty: true,
                    lastModifiedLocallyTimestamp: timestamp,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: newSections,
                        lastModifiedLocallyTimestamp: timestamp,
                        isCurriculumDirty: true
                    })
                };
            });
        },
        deleteSection: function(sectionId) {
            return set(function(state) {
                var _state_selectedLesson;
                var newSections = state.sections.filter(function(s) {
                    return s.id !== sectionId;
                });
                var newSelectedLesson = ((_state_selectedLesson = state.selectedLesson) === null || _state_selectedLesson === void 0 ? void 0 : _state_selectedLesson.sectionId) === sectionId && state.currentEditingCourseId === get().currentEditingCourseId ? null : state.selectedLesson;
                var timestamp = Date.now();
                return {
                    sections: newSections,
                    selectedLesson: newSelectedLesson,
                    isCurriculumDirty: true,
                    lastModifiedLocallyTimestamp: timestamp,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: newSections,
                        selectedLesson: newSelectedLesson,
                        lastModifiedLocallyTimestamp: timestamp,
                        isCurriculumDirty: true
                    })
                };
            });
        },
        moveSection: function(dragIndex, hoverIndex) {
            return set(function(state) {
                var newSections = _to_consumable_array(state.sections);
                var draggedSection = newSections[dragIndex];
                newSections.splice(dragIndex, 1);
                newSections.splice(hoverIndex, 0, draggedSection);
                var reorderedSections = newSections.map(function(s, index) {
                    return _object_spread_props(_object_spread({}, s), {
                        order: index + 1
                    });
                });
                var timestamp = Date.now();
                return {
                    sections: reorderedSections,
                    isCurriculumDirty: true,
                    lastModifiedLocallyTimestamp: timestamp,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: reorderedSections,
                        lastModifiedLocallyTimestamp: timestamp,
                        isCurriculumDirty: true
                    })
                };
            });
        },
        addLesson: function(sectionId, newLesson) {
            var newSelectedLesson = null;
            set(function(state) {
                var sectionIndex = state.sections.findIndex(function(s) {
                    return s.id === sectionId;
                });
                if (sectionIndex === -1) return state;
                var targetSection = state.sections[sectionIndex];
                var newLessonWithOrder = _object_spread_props(_object_spread({}, newLesson), {
                    order: targetSection.lessons.length + 1
                });
                var newSections = state.sections.map(function(s, idx) {
                    return idx === sectionIndex ? _object_spread_props(_object_spread({}, s), {
                        lessons: _to_consumable_array(s.lessons).concat([
                            newLessonWithOrder
                        ])
                    }) : s;
                });
                newSelectedLesson = {
                    sectionId: sectionId,
                    lessonId: newLessonWithOrder.id
                };
                var timestamp = Date.now();
                return {
                    sections: newSections,
                    addingLessonToSectionId: null,
                    isCurriculumDirty: true,
                    lastModifiedLocallyTimestamp: timestamp,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: newSections,
                        selectedLesson: newSelectedLesson,
                        lastModifiedLocallyTimestamp: timestamp,
                        isCurriculumDirty: true
                    })
                };
            });
            return newSelectedLesson; // selector로 가져가려면 set 내부에서 직접 반환 불가, 함수 스코프 변수 사용
        },
        updateLesson: function(sectionId, lessonId, updatedLessonData) {
            return set(function(state) {
                var newSections = state.sections.map(function(s) {
                    if (s.id === sectionId) {
                        return _object_spread_props(_object_spread({}, s), {
                            lessons: s.lessons.map(function(l) {
                                return l.id === lessonId ? _object_spread({}, l, updatedLessonData) : l;
                            })
                        });
                    }
                    return s;
                });
                var timestamp = Date.now();
                return {
                    sections: newSections,
                    editingLessonId: null,
                    isCurriculumDirty: true,
                    lastModifiedLocallyTimestamp: timestamp,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: newSections,
                        lastModifiedLocallyTimestamp: timestamp,
                        isCurriculumDirty: true
                    })
                };
            });
        },
        deleteLesson: function(sectionId, lessonId) {
            return set(function(state) {
                var newSelectedLesson = state.selectedLesson;
                var newSections = state.sections.map(function(s) {
                    if (s.id === sectionId) {
                        var _state_selectedLesson, _state_selectedLesson1;
                        var newLessons = s.lessons.filter(function(l) {
                            return l.id !== lessonId;
                        });
                        // 삭제된 강의가 선택된 강의였다면 선택 해제
                        if (((_state_selectedLesson = state.selectedLesson) === null || _state_selectedLesson === void 0 ? void 0 : _state_selectedLesson.sectionId) === sectionId && ((_state_selectedLesson1 = state.selectedLesson) === null || _state_selectedLesson1 === void 0 ? void 0 : _state_selectedLesson1.lessonId) === lessonId && state.currentEditingCourseId === get().currentEditingCourseId) {
                            newSelectedLesson = null;
                        }
                        return _object_spread_props(_object_spread({}, s), {
                            lessons: newLessons.map(function(l, i) {
                                return _object_spread_props(_object_spread({}, l), {
                                    order: i + 1
                                });
                            })
                        }); // order 재정렬
                    }
                    return s;
                });
                var timestamp = Date.now();
                return {
                    sections: newSections,
                    selectedLesson: newSelectedLesson,
                    isCurriculumDirty: true,
                    lastModifiedLocallyTimestamp: timestamp,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: newSections,
                        selectedLesson: newSelectedLesson,
                        lastModifiedLocallyTimestamp: timestamp,
                        isCurriculumDirty: true
                    })
                };
            });
        },
        moveLesson: function(sectionId, dragIndex, hoverIndex) {
            return set(function(state) {
                var sectionIndex = state.sections.findIndex(function(s) {
                    return s.id === sectionId;
                });
                if (sectionIndex === -1) return state;
                var newSections = _to_consumable_array(state.sections);
                var lessons = _to_consumable_array(newSections[sectionIndex].lessons);
                var draggedLesson = lessons[dragIndex];
                lessons.splice(dragIndex, 1);
                lessons.splice(hoverIndex, 0, draggedLesson);
                newSections[sectionIndex].lessons = lessons.map(function(l, index) {
                    return _object_spread_props(_object_spread({}, l), {
                        order: index + 1
                    });
                });
                var timestamp = Date.now();
                return {
                    sections: newSections,
                    isCurriculumDirty: true,
                    lastModifiedLocallyTimestamp: timestamp,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: newSections,
                        lastModifiedLocallyTimestamp: timestamp,
                        isCurriculumDirty: true
                    })
                };
            });
        },
        setSelectedLesson: function(newSelected) {
            return set(function(state) {
                var newSections = state.sections;
                var nextEditingLessonTitleCache = '';
                var nextEditingLessonMarkdownCache = '';
                if (newSelected) {
                    var section = newSections.find(function(s) {
                        return s.id === newSelected.sectionId;
                    });
                    var lesson = section === null || section === void 0 ? void 0 : section.lessons.find(function(l) {
                        return l.id === newSelected.lessonId;
                    });
                    if (lesson) {
                        nextEditingLessonTitleCache = lesson.title;
                        nextEditingLessonMarkdownCache = lesson.markdown || '';
                    }
                }
                var finalState = {
                    sections: newSections,
                    selectedLesson: newSelected,
                    editingLessonId: newSelected ? newSelected.lessonId : null,
                    editingLessonTitleCache: nextEditingLessonTitleCache,
                    editingLessonMarkdownCache: nextEditingLessonMarkdownCache,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: newSections,
                        selectedLesson: newSelected
                    })
                };
                return finalState;
            });
        },
        updateSelectedLessonTitle: function(newTitle) {
            return set(function(state) {
                if (!state.selectedLesson) return state; // 선택된 강의 없으면 무시
                var _state_selectedLesson = state.selectedLesson, sectionId = _state_selectedLesson.sectionId, lessonId = _state_selectedLesson.lessonId;
                var newSections = state.sections.map(function(s) {
                    if (s.id === sectionId) {
                        return _object_spread_props(_object_spread({}, s), {
                            lessons: s.lessons.map(function(l) {
                                return l.id === lessonId ? _object_spread_props(_object_spread({}, l), {
                                    title: newTitle
                                }) : l;
                            })
                        });
                    }
                    return s;
                });
                var timestamp = Date.now();
                return {
                    sections: newSections,
                    isCurriculumDirty: true,
                    lastModifiedLocallyTimestamp: timestamp,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: newSections,
                        lastModifiedLocallyTimestamp: timestamp,
                        isCurriculumDirty: true
                    })
                };
            });
        },
        updateSelectedLessonMarkdown: function(newMarkdown) {
            return set(function(state) {
                if (!state.selectedLesson) return state;
                var _state_selectedLesson = state.selectedLesson, sectionId = _state_selectedLesson.sectionId, lessonId = _state_selectedLesson.lessonId;
                var newSections = state.sections.map(function(s) {
                    if (s.id === sectionId) {
                        return _object_spread_props(_object_spread({}, s), {
                            lessons: s.lessons.map(function(l) {
                                return l.id === lessonId ? _object_spread_props(_object_spread({}, l), {
                                    markdown: newMarkdown
                                }) : l;
                            })
                        });
                    }
                    return s;
                });
                console.log("[CurriculumStore] updateSelectedLessonMarkdown called. Setting isCurriculumDirty to true. CourseID: ".concat(get().currentEditingCourseId));
                var timestamp = Date.now();
                return {
                    sections: newSections,
                    lastModifiedLocallyTimestamp: timestamp,
                    isCurriculumDirty: true,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: newSections,
                        lastModifiedLocallyTimestamp: timestamp,
                        isCurriculumDirty: true
                    })
                };
            });
        },
        setEditingSection: function(sectionId) {
            var currentTitle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
            return set({
                editingSectionId: sectionId,
                // ID가 null이면 캐시도 초기화, 아니면 전달된 현재 제목으로 설정
                editingSectionTitleCache: sectionId ? currentTitle : ''
            });
        },
        setEditingLesson: function(lessonId) {
            var currentTitle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '', currentMarkdown = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';
            return set(function(state) {
                // UI에서 이 함수를 호출할 때, 해당 강의의 최신 markdown 내용을 전달해야 함.
                // 또는, lessonId를 기반으로 state.sections 에서 직접 찾아오는 방법도 고려 가능.
                // 현재는 인자로 받는 것으로 유지.
                return {
                    editingLessonId: lessonId,
                    editingLessonTitleCache: lessonId ? currentTitle : '',
                    editingLessonMarkdownCache: lessonId ? currentMarkdown : ''
                };
            });
        },
        setIsAddingSection: function(isAdding) {
            return set({
                isAddingSection: isAdding
            });
        },
        setAddingLessonToSectionId: function(sectionId) {
            return set({
                addingLessonToSectionId: sectionId
            });
        },
        setIsCurriculumDirty: function(isDirty) {
            console.log("[CurriculumStore] setIsCurriculumDirty ACTION CALLED! Setting to: ".concat(isDirty));
            set(function(state) {
                return {
                    isCurriculumDirty: isDirty,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        isCurriculumDirty: isDirty
                    })
                };
            });
        },
        setEditingSectionTitleCache: function(title) {
            return set({
                editingSectionTitleCache: title
            });
        },
        setEditingLessonTitleCache: function(title) {
            return set({
                editingLessonTitleCache: title
            });
        },
        setEditingLessonMarkdownCache: function(markdown) {
            return set({
                editingLessonMarkdownCache: markdown
            });
        },
        markAsModified: function() {
            console.log("[CurriculumStore] markAsModified called. Setting isCurriculumDirty to true. CourseID: ".concat(get().currentEditingCourseId));
            set(function(state) {
                var timestamp = Date.now();
                return {
                    lastModifiedLocallyTimestamp: timestamp,
                    isCurriculumDirty: true,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        lastModifiedLocallyTimestamp: timestamp,
                        isCurriculumDirty: true
                    })
                };
            });
        },
        primeLanguageSnapshot: function(courseId, languageCode, snapshot) {
            var _sanitizeLanguageCode;
            var normalizedLanguage = (_sanitizeLanguageCode = sanitizeLanguageCode(languageCode)) !== null && _sanitizeLanguageCode !== void 0 ? _sanitizeLanguageCode : null;
            var snapshotKey = buildSnapshotKey(courseId, normalizedLanguage);
            if (!snapshotKey) {
                return;
            }
            set(function(state) {
                var existing = state.persistedCourseSnapshots[snapshotKey];
                var _snapshot_sections, _ref, _snapshot_lastModifiedLocallyTimestamp, _ref1, _snapshot_isCurriculumDirty, _ref2;
                var nextSnapshot = {
                    sections: cloneSections((_ref = (_snapshot_sections = snapshot.sections) !== null && _snapshot_sections !== void 0 ? _snapshot_sections : existing === null || existing === void 0 ? void 0 : existing.sections) !== null && _ref !== void 0 ? _ref : []),
                    selectedLesson: snapshot.selectedLesson ? _object_spread({}, snapshot.selectedLesson) : (existing === null || existing === void 0 ? void 0 : existing.selectedLesson) ? _object_spread({}, existing.selectedLesson) : null,
                    lastModifiedLocallyTimestamp: (_ref1 = (_snapshot_lastModifiedLocallyTimestamp = snapshot.lastModifiedLocallyTimestamp) !== null && _snapshot_lastModifiedLocallyTimestamp !== void 0 ? _snapshot_lastModifiedLocallyTimestamp : existing === null || existing === void 0 ? void 0 : existing.lastModifiedLocallyTimestamp) !== null && _ref1 !== void 0 ? _ref1 : null,
                    isCurriculumDirty: (_ref2 = (_snapshot_isCurriculumDirty = snapshot.isCurriculumDirty) !== null && _snapshot_isCurriculumDirty !== void 0 ? _snapshot_isCurriculumDirty : existing === null || existing === void 0 ? void 0 : existing.isCurriculumDirty) !== null && _ref2 !== void 0 ? _ref2 : false
                };
                if (existing && sectionsToString(existing.sections || []) === sectionsToString(nextSnapshot.sections || []) && existing.isCurriculumDirty === nextSnapshot.isCurriculumDirty && existing.lastModifiedLocallyTimestamp === nextSnapshot.lastModifiedLocallyTimestamp && JSON.stringify(existing.selectedLesson || null) === JSON.stringify(nextSnapshot.selectedLesson || null)) {
                    return state;
                }
                return {
                    persistedCourseSnapshots: _object_spread_props(_object_spread({}, state.persistedCourseSnapshots), _define_property({}, snapshotKey, nextSnapshot))
                };
            });
        },
        switchLanguage: function(languageCode, options) {
            var normalizedLanguage = sanitizeLanguageCode(languageCode);
            if (!normalizedLanguage) {
                console.warn('[CurriculumStore] switchLanguage: invalid language code provided', languageCode);
                return;
            }
            var stateBefore = get();
            var _options_courseId, _ref;
            var effectiveCourseId = (_ref = (_options_courseId = options === null || options === void 0 ? void 0 : options.courseId) !== null && _options_courseId !== void 0 ? _options_courseId : stateBefore.currentEditingCourseId) !== null && _ref !== void 0 ? _ref : stateBefore.courseId;
            if (!effectiveCourseId) {
                console.warn('[CurriculumStore] switchLanguage: courseId is not set. Unable to switch language.');
                return;
            }
            var snapshotKey = buildSnapshotKey(effectiveCourseId, normalizedLanguage);
            var existingSnapshot = snapshotKey ? stateBefore.persistedCourseSnapshots[snapshotKey] : undefined;
            var _options_fallbackSections;
            var fallbackSections = (_options_fallbackSections = options === null || options === void 0 ? void 0 : options.fallbackSections) !== null && _options_fallbackSections !== void 0 ? _options_fallbackSections : [];
            var _options_markAsDirtyOnImport;
            var markAsDirtyOnImport = (_options_markAsDirtyOnImport = options === null || options === void 0 ? void 0 : options.markAsDirtyOnImport) !== null && _options_markAsDirtyOnImport !== void 0 ? _options_markAsDirtyOnImport : false;
            var _options_providedTimestamp;
            var providedTimestamp = (_options_providedTimestamp = options === null || options === void 0 ? void 0 : options.providedTimestamp) !== null && _options_providedTimestamp !== void 0 ? _options_providedTimestamp : null;
            set(function(state) {
                if (state.currentLanguage === normalizedLanguage && state.currentEditingCourseId === effectiveCourseId) {
                    return state;
                }
                var sectionsToSet;
                var dirtyToSet = false;
                var timestampToSet = providedTimestamp;
                var selectedLesson = null;
                if (existingSnapshot) {
                    sectionsToSet = cloneSections(existingSnapshot.sections || []);
                    dirtyToSet = existingSnapshot.isCurriculumDirty;
                    var _existingSnapshot_lastModifiedLocallyTimestamp;
                    timestampToSet = (_existingSnapshot_lastModifiedLocallyTimestamp = existingSnapshot.lastModifiedLocallyTimestamp) !== null && _existingSnapshot_lastModifiedLocallyTimestamp !== void 0 ? _existingSnapshot_lastModifiedLocallyTimestamp : providedTimestamp;
                    selectedLesson = existingSnapshot.selectedLesson ? _object_spread({}, existingSnapshot.selectedLesson) : null;
                } else {
                    sectionsToSet = cloneSections(fallbackSections || []);
                    dirtyToSet = markAsDirtyOnImport;
                    timestampToSet = markAsDirtyOnImport ? Date.now() : providedTimestamp;
                }
                return {
                    sections: sectionsToSet,
                    currentEditingCourseId: effectiveCourseId,
                    courseId: effectiveCourseId,
                    currentLanguage: normalizedLanguage,
                    selectedLesson: selectedLesson,
                    editingSectionId: null,
                    editingLessonId: null,
                    editingSectionTitleCache: '',
                    editingLessonMarkdownCache: '',
                    isAddingSection: false,
                    addingLessonToSectionId: null,
                    isCurriculumDirty: dirtyToSet,
                    lastModifiedLocallyTimestamp: timestampToSet,
                    persistedCourseSnapshots: updateCourseSnapshot(state, {
                        sections: sectionsToSet,
                        selectedLesson: selectedLesson,
                        lastModifiedLocallyTimestamp: timestampToSet,
                        isCurriculumDirty: dirtyToSet
                    }, effectiveCourseId, normalizedLanguage)
                };
            });
        },
        getLanguageSnapshots: function(courseIdInput) {
            var state = get();
            var effectiveCourseId = courseIdInput !== null && courseIdInput !== void 0 ? courseIdInput : state.currentEditingCourseId;
            var baseKey = buildSnapshotKey(effectiveCourseId);
            if (!baseKey) {
                return {};
            }
            var prefix = "".concat(baseKey, "::");
            var results = {};
            Object.entries(state.persistedCourseSnapshots).forEach(function(param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], snapshot = _param[1];
                if (key === baseKey) {
                    results.default = clonePersistedSnapshot(snapshot);
                } else if (key.startsWith(prefix)) {
                    var languageCode = key.substring(prefix.length) || 'default';
                    results[languageCode] = clonePersistedSnapshot(snapshot);
                }
            });
            return results;
        }
    };
};
// persist 미들웨어를 적용한 스토어 생성
export var useCurriculumStore = create()(persist(curriculumStateCreator, {
    name: CURRICULUM_PERSIST_BASE_KEY,
    version: 2,
    storage: indexedDbStorage,
    partialize: function(state) {
        return {
            persistedCourseSnapshots: normalizePersistedSnapshots(state.persistedCourseSnapshots)
        };
    },
    migrate: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(persistedState, version) {
            var _persistedState_state, snapshots;
            return _ts_generator(this, function(_state) {
                snapshots = normalizePersistedSnapshots(persistedState === null || persistedState === void 0 ? void 0 : (_persistedState_state = persistedState.state) === null || _persistedState_state === void 0 ? void 0 : _persistedState_state.persistedCourseSnapshots);
                return [
                    2,
                    {
                        state: {
                            persistedCourseSnapshots: snapshots
                        },
                        version: 2
                    }
                ];
            });
        });
        return function(persistedState, version) {
            return _ref.apply(this, arguments);
        };
    }(),
    onRehydrateStorage: function() {
        console.log('[CurriculumStore] onRehydrateStorage: Persist middleware attempting to rehydrate.');
        return function(hydratedState, error) {
            if (error) {
                console.error('[CurriculumStore] onRehydrateStorage: Error during rehydration:', error);
                return;
            }
            console.log('[CurriculumStore] onRehydrateStorage: Successfully rehydrated from IndexedDB. Raw hydrated state:', JSON.parse(JSON.stringify(hydratedState || {})));
        };
    }
}));
export var prepareCurriculumStorePersistenceForCourse = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(courseId) {
        var resolvedStorageName, persistApi, snapshotKey, snapshotsBeforeRehydrate, snapshotToCarry, error, snapshotsAfterRehydrate;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    resolvedStorageName = buildPersistStorageName(courseId);
                    persistApi = useCurriculumStore.persist;
                    if (!persistApi) {
                        return [
                            2,
                            resolvedStorageName
                        ];
                    }
                    snapshotKey = buildSnapshotKey(courseId);
                    snapshotsBeforeRehydrate = useCurriculumStore.getState().persistedCourseSnapshots;
                    snapshotToCarry = snapshotKey ? snapshotsBeforeRehydrate[snapshotKey] : undefined;
                    persistApi.setOptions({
                        name: resolvedStorageName
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        persistApi.rehydrate()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error('[CurriculumStore] Failed to rehydrate after updating persist key:', error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    if (!snapshotKey) {
                        return [
                            2,
                            resolvedStorageName
                        ];
                    }
                    snapshotsAfterRehydrate = useCurriculumStore.getState().persistedCourseSnapshots;
                    if (snapshotKey && snapshotToCarry && !snapshotsAfterRehydrate[snapshotKey]) {
                        useCurriculumStore.setState({
                            persistedCourseSnapshots: _object_spread_props(_object_spread({}, snapshotsAfterRehydrate), _define_property({}, snapshotKey, clonePersistedSnapshot(snapshotToCarry)))
                        }, false, 'curriculum/persist/align-course-snapshot');
                    }
                    return [
                        2,
                        resolvedStorageName
                    ];
            }
        });
    });
    return function prepareCurriculumStorePersistenceForCourse(courseId) {
        return _ref.apply(this, arguments);
    };
}(); // 사용 예시:
 // const sections = useCurriculumStore((state) => state.sections);
 // const addSection = useCurriculumStore((state) => state.addSection); 
